
// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import yourIcon from '../assets/greencir.png';
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Container,
//   Paper,
//   useMediaQuery,
//   useTheme,
//   List,
//   ListItem,
//   ListItemText,
//   Popper,
//   Grow,
//   ClickAwayListener,
//   MenuItem,
//   Select,
//   FormControl,
//   FormHelperText,
// } from '@mui/material';

// const AddNewProperty = () => {
//   const navigate = useNavigate();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   // Initialize state from localStorage
//   const [propertyType, setPropertyType] = useState(() => {
//     return localStorage.getItem('propertyType') || '';
//   });

//   const [category, setCategory] = useState(() => {
//     return localStorage.getItem('category') || '';
//   });

//   const [location, setLocation] = useState(() => {
//     return localStorage.getItem('propertyLocation') || '';
//   });

//   // Add this function in AddNewProperty.jsx
//   const clearBasicDetails = () => {
//     // Clear state
//     setPropertyType('');
//     setCategory('');
//     setLocation('');

//     // Clear localStorage
//     localStorage.removeItem('propertyType');
//     localStorage.removeItem('category');
//     localStorage.removeItem('propertyLocation');

//     // Clear errors
//     setLocationError('');
//     setPropertyTypeError('');
//     setCategoryError('');
//   };

//   // Call this when navigating back or on component unmount
//   useEffect(() => {
//     return () => {
//       // Optional: Clear on unmount if needed
//     };
//   }, []);

//   // City suggestions state
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [debounceTimer, setDebounceTimer] = useState(null);

//   // Error states
//   const [locationError, setLocationError] = useState('');
//   const [propertyTypeError, setPropertyTypeError] = useState('');
//   const [categoryError, setCategoryError] = useState('');

//   // In AddNewProperty.jsx, add useEffect to detect navigation source:
//   useEffect(() => {
//     // ✅ Check if we're coming from PropertyDetails (with state)
//     if (location.state && location.state.propertyType) {
//       // Coming from PropertyDetails - restore state
//       const { propertyType: statePropertyType, category: stateCategory, location: stateLocation } = location.state;

//       if (statePropertyType) {
//         setPropertyType(statePropertyType);
//         localStorage.setItem('propertyType', statePropertyType);
//       }
//       if (stateCategory) {
//         setCategory(stateCategory);
//         localStorage.setItem('category', stateCategory);
//       }
//       if (stateLocation) {
//         setLocation(stateLocation);
//         localStorage.setItem('propertyLocation', stateLocation);
//       }
//     } else {
//       // ✅ Coming from navbar/dashboard - data already cleared
//       // Just load from localStorage if available (will be empty if cleared)
//       const savedPropertyType = localStorage.getItem('propertyType');
//       const savedCategory = localStorage.getItem('category');
//       const savedLocation = localStorage.getItem('propertyLocation');

//       if (savedPropertyType) setPropertyType(savedPropertyType);
//       if (savedCategory) setCategory(savedCategory);
//       if (savedLocation) setLocation(savedLocation);
//     }
//   }, [location.state]);

//   // Save to localStorage whenever values change
//   useEffect(() => {
//     if (location) {
//       localStorage.setItem('propertyLocation', location);
//     }
//   }, [location]);

//   useEffect(() => {
//     if (propertyType) {
//       localStorage.setItem('propertyType', propertyType);
//     }
//   }, [propertyType]);

//   useEffect(() => {
//     if (category) {
//       localStorage.setItem('category', category);
//     }
//   }, [category]);

//   // FIXED: Updated to match HeroSection.jsx API structure
//   const fetchCitySuggestions = async (query) => {
//     if (!query || query.trim().length < 1) {
//       setCitySuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }

//     try {
//       const response = await fetch(
//         `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
//       );
//       const data = await response.json();
//       console.log('City API Response:', data);

//       // FIXED: Changed from data.cities to data.data to match HeroSection.jsx
//       if (data.success && data.data && data.data.length > 0) {
//         setCitySuggestions(data.data);
//         setShowSuggestions(true);
//       } else {
//         setCitySuggestions([]);
//         setShowSuggestions(false);
//       }
//     } catch (error) {
//       console.error('Error fetching city suggestions:', error);
//       setCitySuggestions([]);
//       setShowSuggestions(false);
//     }
//   };

//   const handleLocationChange = (e) => {
//     const value = e.target.value;
//     setLocation(value);
//     setAnchorEl(e.currentTarget);

//     // Validation
//     if (!value || value.trim() === '') {
//       setLocationError('Location is required');
//     } else if (value.trim().length < 3) {
//       setLocationError('Location must be at least 3 characters');
//     } else if (value.length > 100) {
//       setLocationError('Location cannot exceed 100 characters');
//     } else {
//       // Allow letters, spaces, commas, dots, hyphens
//       const locationRegex = /^[A-Za-z\s,.-]+$/;
//       if (!locationRegex.test(value)) {
//         setLocationError('Location can only contain letters, spaces, commas, dots, and hyphens');
//       } else {
//         setLocationError('');
//       }
//     }

//     // FIXED: Added debouncing like in HeroSection.jsx
//     if (debounceTimer) {
//       clearTimeout(debounceTimer);
//     }

//     const newTimer = setTimeout(() => {
//       if (value.trim().length >= 1) {
//         fetchCitySuggestions(value.trim());
//       } else {
//         setCitySuggestions([]);
//         setShowSuggestions(false);
//       }
//     }, 300);

//     setDebounceTimer(newTimer);
//   };

//   const handleSelectCity = (city) => {
//     // Set the city name
//     const cityName = city.name;
//     setLocation(cityName);
//     setShowSuggestions(false);
//     setLocationError('');

//     // Save to localStorage immediately
//     localStorage.setItem('propertyLocation', cityName);
//   };

//   const handleClickAway = () => {
//     setShowSuggestions(false);
//   };

//   const handleBack = () => {
//     // Optional: Navigate back or clear form
//     // navigate(-1);
//   };

//   const handleNext = () => {
//     // Validate all fields
//     let hasError = false;

//     // Validate Property Type
//     if (!propertyType || propertyType.trim() === '') {
//       setPropertyTypeError('Property Type is required');
//       hasError = true;
//     } else {
//       setPropertyTypeError('');
//     }

//     // Validate Category
//     if (!category || category.trim() === '') {
//       setCategoryError('Category is required');
//       hasError = true;
//     } else {
//       setCategoryError('');
//     }

//     // Validate Location
//     if (!location || location.trim() === '') {
//       setLocationError('Location is required');
//       hasError = true;
//     } else if (location.trim().length < 3) {
//       setLocationError('Location must be at least 3 characters');
//       hasError = true;
//     } else {
//       const locationRegex = /^[A-Za-z\s,.-]+$/;
//       if (!locationRegex.test(location)) {
//         setLocationError('Location can only contain letters, spaces, commas, dots, and hyphens');
//         hasError = true;
//       } else {
//         setLocationError('');
//       }
//     }

//     // If there are errors, don't proceed
//     if (hasError) {
//       console.log('Validation failed. Please fix errors.');
//       return;
//     }

//     // ✅ Prepare data object with explicit field names
//     const basicDetails = {
//       // Core fields
//       propertyType: propertyType.trim(),
//       category: category.trim(),
//       location: location.trim(),

//       // Additional metadata (useful for tracking)
//       property_type: propertyType.toLowerCase().trim(), // 'residential' or 'commercial'
//       category_value: category.toLowerCase().trim(), // 'sell' or 'rent'
//       city: location.trim(),

//       // Timestamp for tracking
//       timestamp: new Date().toISOString()
//     };

//     // Log for debugging
//     console.log('=== BASIC DETAILS - NAVIGATING TO PROPERTY DETAILS ===');
//     console.log('Property Type:', basicDetails.propertyType);
//     console.log('Category:', basicDetails.category);
//     console.log('Location:', basicDetails.location);
//     console.log('Full Data:', basicDetails);
//     console.log('======================================================');

//     // Navigate to PropertyDetails with the data
//     navigate('/property-details', {
//       state: basicDetails
//     });
//   };

//   return (
//     <Container maxWidth="md" sx={{ mb: 6, px: { xs: 1, sm: 2, md: 3 } }}>
//       <Paper
//         elevation={0}
//         sx={{
//           width: '100%',
//           maxWidth: { xs: '90%', sm: '1200px' },
//           p: { xs: 2, sm: 4 },
//           mt: { xs: 4, sm: 8 },
//           mb: 4,
//           backgroundColor: '#ffffff',
//           borderRadius: 2,
//           border: '1px solid #e0e0e0',
//           mx: 'auto'
//         }}
//       >
//         {/* Progress Steps */}
//         <Box sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//           mb: isMobile ? 3 : 4,
//           px: isMobile ? 1 : 0
//         }}>
//           <Box sx={{
//             display: 'flex',
//             alignItems: 'center',
//             flexDirection: isMobile ? 'column' : 'row',
//             gap: isMobile ? 2 : 0
//           }}>
//             {/* Step 1 - Active */}
//             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <Typography sx={{
//                 mb: 1,
//                 fontSize: isMobile ? '14px' : '16px',
//                 fontWeight: 'normal',
//                 color: 'black',
//                 fontFamily: 'Outfit',
//                 textAlign: 'center'
//               }}>
//                 Basic Details
//               </Typography>
//               <Box sx={{
//                 width: isMobile ? 30 : 35,
//                 height: isMobile ? 30 : 35,
//                 borderRadius: '50%',
//                 border: '3px solid #1a507d',
//                 backgroundColor: 'white',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}>
//                 <Box sx={{
//                   width: isMobile ? 18 : 22,
//                   height: isMobile ? 18 : 22,
//                   backgroundColor: '#1c274c',
//                   borderRadius: '50%'
//                 }} />
//               </Box>
//             </Box>

//             {/* Divider */}
//             <Box sx={{
//               width: isMobile ? '1px' : '100px',
//               height: isMobile ? '20px' : '1px',
//               backgroundColor: '#d0d0d0',
//               mx: isMobile ? 0 : 2,
//               my: isMobile ? 1 : 0
//             }} />

//             {/* Step 2 - Inactive */}
//             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <Typography sx={{
//                 mb: 1,
//                 fontSize: isMobile ? '14px' : '16px',
//                 fontWeight: 'normal',
//                 color: 'black',
//                 fontFamily: 'Outfit',
//                 textAlign: 'center'
//               }}>
//                 Property Details
//               </Typography>
//               <Box sx={{
//                 width: isMobile ? 30 : 35,
//                 height: isMobile ? 30 : 35,
//                 borderRadius: '50%',
//                 backgroundColor: '#ebf6ff'
//               }} />
//             </Box>

//             {/* Divider */}
//             <Box sx={{
//               width: isMobile ? '1px' : '100px',
//               height: isMobile ? '20px' : '1px',
//               backgroundColor: '#d0d0d0',
//               mx: isMobile ? 0 : 2,
//               my: isMobile ? 1 : 0
//             }} />

//             {/* Step 3 - Inactive */}
//             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//               <Typography sx={{
//                 mb: 1,
//                 fontSize: isMobile ? '14px' : '16px',
//                 fontWeight: 'normal',
//                 color: 'black',
//                 fontFamily: 'Outfit',
//                 textAlign: 'center'
//               }}>
//                 Price Details
//               </Typography>
//               <Box sx={{
//                 width: isMobile ? 30 : 35,
//                 height: isMobile ? 30 : 35,
//                 borderRadius: '50%',
//                 backgroundColor: '#ebf6ff'
//               }} />
//             </Box>
//           </Box>
//         </Box>

//         {/* Form Title */}
//         <Typography
//           variant="h5"
//           sx={{
//             fontFamily: 'Outfit, sans-serif',
//             fontWeight: 500,
//             color: '#333333',
//             mb: 4,
//             fontSize: { xs: '20px', sm: '24px' }
//           }}
//         >
//           Add Basic Details
//         </Typography>

//         {/* Property Type and Category - Side by Side with Dropdowns */}
//         <Box sx={{ 
//           display: 'flex', 
//           flexDirection: { xs: 'column', sm: 'row' }, 
//           gap: 2, 
//           mb: 3 
//         }}>
//           {/* Property Type Dropdown */}
//           <Box sx={{ flex: 1 }}>
//             <Typography variant="body1" sx={{
//               fontFamily: 'Outfit, sans-serif',
//               fontWeight: 500,
//               color: '#333333',
//               mb: 2,
//               fontSize: '14px'
//             }}>
//               Select Property <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <FormControl fullWidth error={!!propertyTypeError}>
//               <Select
//                 value={propertyType}
//                 onChange={(e) => {
//                   setPropertyType(e.target.value);
//                   setPropertyTypeError('');
//                 }}
//                 displayEmpty
//                 sx={{
//                   borderRadius: 2,
//                   backgroundColor: '#ffffff',
//                   fontFamily: 'Outfit, sans-serif',
//                   fontSize: '14px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#e0e0e0'
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#bdbdbd'
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#1976d2'
//                   }
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <em style={{ color: '#999999' }}>Select Property</em>
//                 </MenuItem>
//                 <MenuItem value="Residential" sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '14px' }}>
//                   Residential
//                 </MenuItem>
//                 <MenuItem value="Commercial" sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '14px' }}>
//                   Commercial
//                 </MenuItem>
//               </Select>
//               {propertyTypeError && (
//                 <FormHelperText sx={{ fontFamily: 'Outfit, sans-serif' }}>
//                   {propertyTypeError}
//                 </FormHelperText>
//               )}
//             </FormControl>
//           </Box>

//           {/* Category Dropdown */}
//           <Box sx={{ flex: 1 }}>
//             <Typography variant="body1" sx={{
//               fontFamily: 'Outfit, sans-serif',
//               fontWeight: 500,
//               color: '#333333',
//               mb: 2,
//               fontSize: '14px'
//             }}>
//               Select Category <span style={{ color: '#d32f2f' }}>*</span>
//             </Typography>
//             <FormControl fullWidth error={!!categoryError}>
//               <Select
//                 value={category}
//                 onChange={(e) => {
//                   setCategory(e.target.value);
//                   setCategoryError('');
//                 }}
//                 displayEmpty
//                 sx={{
//                   borderRadius: 2,
//                   backgroundColor: '#ffffff',
//                   fontFamily: 'Outfit, sans-serif',
//                   fontSize: '14px',
//                   '& .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#e0e0e0'
//                   },
//                   '&:hover .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#bdbdbd'
//                   },
//                   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                     borderColor: '#1976d2'
//                   }
//                 }}
//               >
//                 <MenuItem value="" disabled>
//                   <em style={{ color: '#999999' }}>Select Category</em>
//                 </MenuItem>
//                 <MenuItem value="Sell" sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '14px' }}>
//                   Sell
//                 </MenuItem>
//                 <MenuItem value="Rent" sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '14px' }}>
//                   Rent
//                 </MenuItem>
//               </Select>
//               {categoryError && (
//                 <FormHelperText sx={{ fontFamily: 'Outfit, sans-serif' }}>
//                   {categoryError}
//                 </FormHelperText>
//               )}
//             </FormControl>
//           </Box>
//         </Box>

//         {/* Location - FIXED: Dropdown now appears downward */}
//         <Box sx={{ maxWidth: 500, width: '100%', mb: 3, position: 'relative' }}>
//           <Typography
//             variant="body1"
//             sx={{
//               fontFamily: 'Outfit, sans-serif',
//               fontWeight: 500,
//               color: '#333333',
//               mb: 2,
//               fontSize: '14px'
//             }}
//           >
//             Enter City <span style={{ color: '#d32f2f' }}>*</span>
//           </Typography>

//           <ClickAwayListener onClickAway={handleClickAway}>
//             <Box>
//               <TextField
//                 fullWidth
//                 placeholder="Enter Location"
//                 value={location}
//                 type="text"
//                 onChange={handleLocationChange}
//                 onFocus={() => {
//                   if (location.trim().length >= 1 && citySuggestions.length > 0) {
//                     setShowSuggestions(true);
//                   }
//                 }}
//                 error={!!locationError}
//                 helperText={locationError}
//                 inputProps={{
//                   maxLength: 100
//                 }}
//                 sx={{
//                   '& .MuiOutlinedInput-root': {
//                     borderRadius: 2,
//                     backgroundColor: '#ffffff',
//                     '& fieldset': { borderColor: '#e0e0e0' },
//                     '&:hover fieldset': { borderColor: '#bdbdbd' },
//                     '&.Mui-focused fieldset': { borderColor: '#1976d2' }
//                   },
//                   '& .MuiInputBase-input': {
//                     fontFamily: 'Outfit, sans-serif',
//                     fontSize: '14px',
//                     color: '#666666',
//                     py: 1.5
//                   },
//                   '& .MuiInputBase-input::placeholder': { color: '#999999', opacity: 1 }
//                 }}
//               />

//               {showSuggestions && citySuggestions.length > 0 && (
//                 <Popper
//                   open={showSuggestions}
//                   anchorEl={anchorEl}
//                   placement="bottom-start"
//                   transition
//                   modifiers={[
//                     {
//                       name: 'flip',
//                       enabled: false, // FIXED: Disable flip to prevent upward opening
//                     },
//                     {
//                       name: 'preventOverflow',
//                       enabled: true,
//                       options: {
//                         altAxis: true,
//                         altBoundary: true,
//                         tether: false,
//                         rootBoundary: 'viewport',
//                         padding: 8,
//                       },
//                     },
//                   ]}
//                   style={{ width: anchorEl ? anchorEl.clientWidth : 'auto', zIndex: 1300 }}
//                 >
//                   {({ TransitionProps }) => (
//                     <Grow {...TransitionProps} timeout={200}>
//                       <Paper
//                         elevation={3}
//                         sx={{
//                           maxHeight: 200,
//                           overflow: 'auto',
//                           mt: 0.5,
//                           border: '1px solid #e0e0e0',
//                           borderRadius: 1
//                         }}
//                       >
//                         <List dense>
//                           {citySuggestions.map((city, index) => (
//                             <ListItem
//                               key={`city-${city.id}-${index}`}
//                               button
//                               onClick={() => handleSelectCity(city)}
//                               sx={{
//                                 py: 1,
//                                 '&:hover': {
//                                   backgroundColor: '#f5f5f5'
//                                 }
//                               }}
//                             >
//                               <ListItemText
//                                 primary={city.name}
//                                 secondary={city.state_name || city.state}
//                                 primaryTypographyProps={{
//                                   fontFamily: 'Outfit, sans-serif',
//                                   fontWeight: 500,
//                                   fontSize: '14px'
//                                 }}
//                                 secondaryTypographyProps={{
//                                   fontFamily: 'Outfit, sans-serif',
//                                   fontSize: '12px'
//                                 }}
//                               />
//                             </ListItem>
//                           ))}
//                         </List>
//                       </Paper>
//                     </Grow>
//                   )}
//                 </Popper>
//               )}
//             </Box>
//           </ClickAwayListener>
//         </Box>

//         {/* Buttons */}
//         <Box sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', sm: 'row' },
//           gap: { xs: 2, sm: 0 },
//           justifyContent: 'space-between'
//         }}>
//           <Button
//             fullWidth={isMobile}
//             onClick={handleBack}
//             sx={{
//               px: 4, py: 1.5, borderRadius: 2, textTransform: 'none',
//               fontFamily: 'Outfit, sans-serif', fontSize: '14px', fontWeight: 500,
//               backgroundColor: '#9e9e9e',
//               color: '#ffffff',
//               order: { xs: 2, sm: 1 },
//               '&:hover': { backgroundColor: '#757575' }
//             }}
//           >
//             Back
//           </Button>

//           <Button
//             fullWidth={isMobile}
//             onClick={handleNext}
//             sx={{
//               px: 4, py: 1.5, borderRadius: 2, textTransform: 'none',
//               fontFamily: 'Outfit, sans-serif', fontSize: '14px', fontWeight: 500,
//               backgroundColor: '#1976d2',
//               color: '#ffffff',
//               order: { xs: 1, sm: 2 },
//               '&:hover': { backgroundColor: '#1565c0' }
//             }}
//           >
//             Next
//           </Button>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default AddNewProperty;


import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  TextField,
  Container,
  Paper,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemText,
  Popper,
  Grow,
  ClickAwayListener,
  MenuItem,
  Select,
  FormControl,
  FormHelperText,
  styled,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

// Custom Stepper Connector for Desktop
const CustomStepConnector = styled('div')(({ theme }) => ({
  width: 2,
  height: 40,
  backgroundColor: '#e0e0e0',
  marginLeft: 13,
  marginTop: 4,
  marginBottom: 4,
}));

// Custom Stepper Connector for Mobile (Horizontal)
const CustomStepConnectorHorizontal = styled('div')(({ theme }) => ({
  width: 50,
  height: 2,
  backgroundColor: '#e0e0e0',
}));

// Custom Step Icon
const CustomStepIcon = ({ active, completed, isMobile }) => {
  const size = isMobile ? 24 : 28;
  const innerSize = isMobile ? 12 : 14;

  if (completed) {
    return <CheckCircleIcon sx={{ color: '#4caf50', fontSize: size }} />;
  }

  if (active) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: '3px solid #1976d2',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
        }}
      >
        <Box
          sx={{
            width: innerSize,
            height: innerSize,
            borderRadius: '50%',
            backgroundColor: '#1976d2',
          }}
        />
      </Box>
    );
  }

  return <RadioButtonUncheckedIcon sx={{ color: '#e0e0e0', fontSize: size }} />;
};

const AddNewProperty = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  // State management
  const [propertyType, setPropertyType] = useState(() => {
    return localStorage.getItem('propertyType') || '';
  });

  const [category, setCategory] = useState(() => {
    return localStorage.getItem('category') || '';
  });

  const [location, setLocation] = useState(() => {
    return localStorage.getItem('propertyLocation') || '';
  });

  // City suggestions
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [debounceTimer, setDebounceTimer] = useState(null);

  // Error states
  const [locationError, setLocationError] = useState('');
  const [propertyTypeError, setPropertyTypeError] = useState('');
  const [categoryError, setCategoryError] = useState('');

  // Stepper steps
  const steps = ['Basic Details', 'Property Details', 'Price Details'];
  const activeStep = 0;

  // Calculate completion percentage
  const calculateProgress = () => {
    let filledFields = 0;
    const totalFields = 3;

    if (propertyType) filledFields++;
    if (category) filledFields++;
    if (location) filledFields++;

    return Math.round((filledFields / totalFields) * 100);
  };

  const progress = calculateProgress();

  // Save to localStorage
  useEffect(() => {
    if (location) localStorage.setItem('propertyLocation', location);
  }, [location]);

  useEffect(() => {
    if (propertyType) localStorage.setItem('propertyType', propertyType);
  }, [propertyType]);

  useEffect(() => {
    if (category) localStorage.setItem('category', category);
  }, [category]);

  // ✅ Cleanup when component unmounts (user leaves the page)
  useEffect(() => {
    return () => {
      // Only clear if navigating away from the flow
      const currentPath = window.location.pathname;
      const flowPages = ['/add-new-property', '/property-details', '/amenities', '/price-details', '/rent-details'];
      
      if (!flowPages.includes(currentPath)) {
        localStorage.removeItem('propertyImagePreviews');
        localStorage.removeItem('propertyDetailsFormState');
        localStorage.removeItem('propertyType');
        localStorage.removeItem('category');
        localStorage.removeItem('propertyLocation');
        localStorage.removeItem('amenities_society');
        localStorage.removeItem('amenities_furnishing');
        localStorage.removeItem('amenities_other');
      }
    };
  }, []);

  // Fetch city suggestions
  const fetchCitySuggestions = async (query) => {
    if (!query || query.trim().length < 1) {
      setCitySuggestions([]);
      setShowSuggestions(false);
      return;
    }

    try {
      const response = await fetch(
        `https://propertydealstalk.com/api/property/cities?q=${encodeURIComponent(query)}`
      );
      const data = await response.json();

      if (data.success && data.data && data.data.length > 0) {
        setCitySuggestions(data.data);
        setShowSuggestions(true);
      } else {
        setCitySuggestions([]);
        setShowSuggestions(false);
      }
    } catch (error) {
      console.error('Error fetching city suggestions:', error);
      setCitySuggestions([]);
      setShowSuggestions(false);
    }
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setLocation(value);
    setAnchorEl(e.currentTarget);

    // Validation
    if (!value || value.trim() === '') {
      setLocationError('Location is required');
    } else if (value.trim().length < 3) {
      setLocationError('Location must be at least 3 characters');
    } else {
      setLocationError('');
    }

    // Debouncing
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    const newTimer = setTimeout(() => {
      if (value.trim().length >= 1) {
        fetchCitySuggestions(value.trim());
      } else {
        setCitySuggestions([]);
        setShowSuggestions(false);
      }
    }, 300);

    setDebounceTimer(newTimer);
  };

  const handleSelectCity = (city) => {
    const cityName = city.name;
    setLocation(cityName);
    setShowSuggestions(false);
    setLocationError('');
    localStorage.setItem('propertyLocation', cityName);
  };

  const handleClickAway = () => {
    setShowSuggestions(false);
  };

  const handleNext = () => {
    // Validation
    let hasError = false;

    if (!propertyType || propertyType.trim() === '') {
      setPropertyTypeError('Property Type is required');
      hasError = true;
    } else {
      setPropertyTypeError('');
    }

    if (!category || category.trim() === '') {
      setCategoryError('Category is required');
      hasError = true;
    } else {
      setCategoryError('');
    }

    if (!location || location.trim() === '') {
      setLocationError('Location is required');
      hasError = true;
    } else {
      setLocationError('');
    }

    if (hasError) return;

    // Navigate to next screen
    const basicDetails = {
      propertyType: propertyType.trim(),
      category: category.trim(),
      location: location.trim(),
      property_type: propertyType.toLowerCase().trim(),
      category_value: category.toLowerCase().trim(),
      city: location.trim(),
      timestamp: new Date().toISOString(),
    };

    navigate('/property-details', { state: basicDetails });
  };

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 2, md: 3 } }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: { xs: 2, md: 3 },
          justifyContent: 'center',
          maxWidth: '1050px',
          margin: '0 auto',
        }}
      >
        {/* Left Sidebar - Stepper (Desktop) / Top Stepper (Mobile) */}
        <Paper
          elevation={0}
          sx={{
            width: { xs: '100%', md: '280px' },
            p: { xs: 2.5, md: 3 },
            backgroundColor: '#f8f9fa',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
            display: 'flex',
            flexDirection: 'column',
            alignItems: { xs: 'stretch', md: 'flex-start' },
            justifyContent: { xs: 'flex-start', md: 'center' },
            minHeight: { md: '400px' },
            position: { md: 'sticky' },
            top: { md: 20 },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 600,
              mb: { xs: 2.5, md: 4 },
              fontSize: { xs: '16px', md: '18px' },
              textAlign: { xs: 'left', md: 'left' },
              width: '100%',
            }}
          >
            Post your property
          </Typography>

          {/* Desktop Stepper - Vertical */}
          {!isMobile && (
            <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              {steps.map((label, index) => (
                <Box key={label}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <CustomStepIcon
                      active={index === activeStep}
                      completed={index < activeStep}
                      isMobile={false}
                    />
                    <Typography
                      sx={{
                        fontFamily: 'Outfit',
                        fontSize: '14px',
                        fontWeight: index === activeStep ? 600 : 400,
                        color:
                          index === activeStep
                            ? '#1976d2'
                            : index < activeStep
                            ? '#4caf50'
                            : '#666',
                      }}
                    >
                      {label}
                    </Typography>
                  </Box>
                  {index < steps.length - 1 && <CustomStepConnector />}
                </Box>
              ))}
            </Box>
          )}

          {/* Mobile Stepper - Horizontal */}
          {isMobile && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              {steps.map((label, index) => (
                <React.Fragment key={label}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: index < steps.length - 1 ? 0 : 'none' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0 }}>
                      <CustomStepIcon
                        active={index === activeStep}
                        completed={index < activeStep}
                        isMobile={true}
                      />
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: 'Outfit',
                        fontSize: '11px',
                        fontWeight: index === activeStep ? 600 : 400,
                        color:
                          index === activeStep
                            ? '#1976d2'
                            : index < activeStep
                            ? '#4caf50'
                            : '#666',
                        mt: 0.8,
                        textAlign: 'center',
                        maxWidth: '70px',
                        lineHeight: 1.2,
                      }}
                    >
                      {label}
                    </Typography>
                  </Box>
                  {index < steps.length - 1 && (
                    <Box sx={{ display: 'flex', alignItems: 'center', pt: '10px', pb: '18px' }}>
                      <CustomStepConnectorHorizontal />
                    </Box>
                  )}
                </React.Fragment>
              ))}
            </Box>
          )}
        </Paper>

        {/* Main Content Area */}
        <Paper
          elevation={0}
          sx={{
            flex: 1,
            maxWidth: { xs: '100%', md: '700px' },
            p: { xs: 2.5, sm: 3, md: 3.5 },
            backgroundColor: '#ffffff',
            borderRadius: 2,
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontFamily: 'Outfit',
              fontWeight: 600,
              mb: 0.5,
              fontSize: { xs: '18px', md: '22px' },
            }}
          >
            Add Basic Details
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Outfit',
              fontSize: '13px',
              color: '#666',
              mb: 3,
            }}
          >
            {progress}% <span style={{ color: '#4caf50' }}>●●○○○</span>
          </Typography>

          {/* Form Fields in Grid */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
              gap: { xs: 2, sm: 2.5 },
            }}
          >
            {/* Property Type */}
            <FormControl fullWidth error={!!propertyTypeError}>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontSize: '13px',
                  fontWeight: 500,
                  mb: 0.8,
                }}
              >
                Select Property <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Select
                value={propertyType}
                onChange={(e) => {
                  setPropertyType(e.target.value);
                  setPropertyTypeError('');
                }}
                displayEmpty
                size="small"
                sx={{
                  borderRadius: 1.5,
                  fontFamily: 'Outfit',
                  fontSize: '13px',
                  '& .MuiSelect-select': {
                    py: 1.2,
                  },
                }}
              >
                <MenuItem value="" disabled>
                  <em>Select Property</em>
                </MenuItem>
                <MenuItem value="Residential">Residential</MenuItem>
                <MenuItem value="Commercial">Commercial</MenuItem>
              </Select>
              {propertyTypeError && (
                <FormHelperText sx={{ fontSize: '11px' }}>{propertyTypeError}</FormHelperText>
              )}
            </FormControl>

            {/* Category */}
            <FormControl fullWidth error={!!categoryError}>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontSize: '13px',
                  fontWeight: 500,
                  mb: 0.8,
                }}
              >
                Select Category <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <Select
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setCategoryError('');
                }}
                displayEmpty
                size="small"
                sx={{
                  borderRadius: 1.5,
                  fontFamily: 'Outfit',
                  fontSize: '13px',
                  '& .MuiSelect-select': {
                    py: 1.2,
                  },
                }}
              >
                <MenuItem value="" disabled>
                  <em>Select Category</em>
                </MenuItem>
                <MenuItem value="Sell">Sell</MenuItem>
                <MenuItem value="Rent">Rent</MenuItem>
              </Select>
              {categoryError && (
                <FormHelperText sx={{ fontSize: '11px' }}>{categoryError}</FormHelperText>
              )}
            </FormControl>

            {/* Location - Matching Width of Property Type */}
            <Box sx={{ gridColumn: { xs: '1', sm: '1' } }}>
              <Typography
                sx={{
                  fontFamily: 'Outfit',
                  fontSize: '13px',
                  fontWeight: 500,
                  mb: 0.8,
                  mt: { xs: 0, sm: 2.5 },
                }}
              >
                Enter City <span style={{ color: '#d32f2f' }}>*</span>
              </Typography>
              <ClickAwayListener onClickAway={handleClickAway}>
                <Box sx={{ position: 'relative' }}>
                  <TextField
                    fullWidth
                    placeholder="Enter Location"
                    value={location}
                    onChange={handleLocationChange}
                    error={!!locationError}
                    helperText={locationError}
                    size="small"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 1.5,
                        fontFamily: 'Outfit',
                        fontSize: '13px',
                      },
                      '& .MuiInputBase-input': {
                        py: 1.2,
                      },
                      '& .MuiFormHelperText-root': {
                        fontSize: '11px',
                      },
                    }}
                  />
                  {showSuggestions && citySuggestions.length > 0 && (
                    <Popper
                      open={showSuggestions}
                      anchorEl={anchorEl}
                      placement="bottom-start"
                      transition
                      style={{
                        width: anchorEl ? anchorEl.clientWidth : 'auto',
                        zIndex: 1300,
                      }}
                    >
                      {({ TransitionProps }) => (
                        <Grow {...TransitionProps} timeout={200}>
                          <Paper
                            elevation={3}
                            sx={{
                              maxHeight: 200,
                              overflow: 'auto',
                              mt: 0.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                            }}
                          >
                            <List dense>
                              {citySuggestions.map((city, index) => (
                                <ListItem
                                  key={`city-${city.id}-${index}`}
                                  button
                                  onClick={() => handleSelectCity(city)}
                                  sx={{
                                    py: 0.8,
                                    '&:hover': {
                                      backgroundColor: '#f5f5f5',
                                    },
                                  }}
                                >
                                  <ListItemText
                                    primary={city.name}
                                    secondary={city.state_name || city.state}
                                    primaryTypographyProps={{
                                      fontFamily: 'Outfit',
                                      fontWeight: 500,
                                      fontSize: '13px',
                                    }}
                                    secondaryTypographyProps={{
                                      fontFamily: 'Outfit',
                                      fontSize: '11px',
                                    }}
                                  />
                                </ListItem>
                              ))}
                            </List>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  )}
                </Box>
              </ClickAwayListener>
            </Box>
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 2,
              mt: 4,
            }}
          >
            <Button
              variant="outlined"
              sx={{
                px: 3,
                py: 1,
                borderRadius: 1.5,
                textTransform: 'none',
                fontFamily: 'Outfit',
                fontSize: '13px',
                color: '#666',
                borderColor: '#e0e0e0',
                minWidth: { xs: '80px', sm: '100px' },
              }}
            >
              Back
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              sx={{
                px: 3,
                py: 1,
                borderRadius: 1.5,
                textTransform: 'none',
                fontFamily: 'Outfit',
                fontSize: '13px',
                backgroundColor: '#1976d2',
                minWidth: { xs: '80px', sm: '100px' },
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
              }}
            >
              Next
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AddNewProperty;